export default __webpack_public_path__ + "static/media/sectionImg.95b614f7.png";